import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { UI_MODE } from 'framework-listing-lib/constants';
import ListingLibMoveAssetsModal from 'framework-listing-lib/dialog/ListingLibMoveAssetsModal';
import { hasTeamFormPartitioning, hasContentTeamAssignment, hasFormsWriteAccess, hasComparisonToolAccess } from 'FormsUI/selectors/Scope';
import { usePopover } from 'FormsUI/components/dashboard/frameworkTable/OpenPopoverProvider';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { SELECTION_MODES } from '../constants';
import DeleteBulkAction from './DeleteBulkAction';
import ManageAccessBulkAction from './ManageAccessBulkAction';
import CompareBulkActionComparisonAllowed from './CompareBulkAction/CompareBulkActionComparisonAllowed';
import CompareBulkActionComparisonDisallowed from './CompareBulkAction/CompareBulkActionComparisonDisallowed';
import MultiAccountCopyAction from './MultiAccountCopyAction/MultiAccountCopyAction';
import { useHasAssetCopierAccess } from 'ui-multi-account-asset-copier';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { FolderOpenIcon } from 'foundations-assets/icons/components/FolderOpenIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BulkActions = props => {
  const {
    onClearSelection,
    selectedObjects,
    selectionMode,
    uiMode
  } = props;
  const isComparisonAllowed = useSelector(hasComparisonToolAccess);
  const teamFormPartitioningAccess = useSelector(hasTeamFormPartitioning);
  const contentTeamAssignmentAccess = useSelector(hasContentTeamAssignment);
  const canWriteToForms = useSelector(hasFormsWriteAccess);
  const canAssignTeams = teamFormPartitioningAccess && contentTeamAssignmentAccess;
  const {
    hasAssetCopierAccess
  } = useHasAssetCopierAccess();
  const {
    showPopover,
    hidePopover
  } = usePopover();
  const handleCloseModal = useCallback(() => {
    hidePopover();
    onClearSelection();
  }, [onClearSelection, hidePopover]);
  const trackAction = action => trackDashboardInteraction(action, {
    via: 'bulk-actions'
  });
  const Popover = /*#__PURE__*/_jsx(ListingLibMoveAssetsModal, {
    selectedObjectOrObjects: selectedObjects,
    onClose: handleCloseModal
  });
  const handleShowMoveToFolder = () => {
    showPopover(Popover);
  };
  const MoveToFolder = () => selectionMode !== SELECTION_MODES.ALL ? /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "permissions.disallowed"
    }),
    placement: "left",
    disabled: canWriteToForms,
    children: /*#__PURE__*/_jsxs(Button, {
      disabled: !canWriteToForms,
      onClick: handleShowMoveToFolder,
      use: "link",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FolderOpenIcon, {})
      }), uiMode === UI_MODE.LIST ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "moveToFolder"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "move"
      })]
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsxs(List, {
    inline: true,
    children: [uiMode === UI_MODE.FOLDERS && /*#__PURE__*/_jsx(MoveToFolder, {}), canAssignTeams && /*#__PURE__*/_jsx(ManageAccessBulkAction, Object.assign({
      trackAction: trackAction
    }, props)), /*#__PURE__*/_jsx(DeleteBulkAction, Object.assign({}, props)), isComparisonAllowed ? /*#__PURE__*/_jsx(CompareBulkActionComparisonAllowed, Object.assign({}, props)) : /*#__PURE__*/_jsx(CompareBulkActionComparisonDisallowed, Object.assign({}, props)), hasAssetCopierAccess && /*#__PURE__*/_jsx(MultiAccountCopyAction, {
      selectedObjects: selectedObjects
    })]
  });
};
export default BulkActions;